import { Box, Grid } from "atoms";
import React from "react";
import { Sidebar } from "organisms/Sidebar";
import { DashboardHeader } from "organisms";

const DashboardLayout = ({ children }) => {
  return (
    <Grid
      gridTemplateColumns={{ lg: "23.5rem 1fr" }}
      height="100vh"
      bg="background.200"
      gridGap="3.15rem"
      pr="2rem"
    >
      <Grid bg="white">
        <Sidebar isExpanded />
      </Grid>
      <Grid mt="1.8rem" gridRowGap="2rem" alignContent="start">
        <DashboardHeader />
        <Box
          height="calc(100vh - 10rem)"
          overflowY="auto"
          className="hide-scrollbar"
        >
          {children}
        </Box>
      </Grid>
    </Grid>
  );
};

export default DashboardLayout;
